/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';

import MyProfileEditController from './MyProfileEdit.controller';
import { getLoggedInUser, getActiveProfile, getActiveProfileId, getMainProfileId } from '../../redux/reduxSelectors';
import NavigationActions from '../../redux/NavigationActions';
import ProfileActions from '../../redux/ProfileActions';
import { actions as systemNotificationActions } from '../../../redux/ducks/systemNotification';
import { selectors as listSelectors } from '../../../redux/ducks/lists/lists';
import { actions as systemModalActions } from '../../../redux/ducks/systemModal';
import { selectors as ownerSelectors } from '../../../redux/ducks/owners';
import { selectors as integrationsSelectors } from '../../../redux/ducks/integrations';

import RouteNames from '../../RouteNames';

function mapStateToProps(state, routerProps) {
  const history = routerProps.history;
  const profile = getActiveProfile(state);
  const genderCollection = listSelectors.getGenderCollection(state);
  const activeOwnerProfiles = ownerSelectors.getActiveOwnersForProfile(profile.data.id, state);

  const genderIdMap = {};
  genderCollection.forEach((g) => {
    genderIdMap[g.id] = g;
  });

  return {
    user: getLoggedInUser(state),
    propertyName: routerProps.match.params.propertyName,
    profile,
    isMainProfile: getActiveProfileId(state) === getMainProfileId(state),
    hasIntegrations: integrationsSelectors.hasIntegrations(state, profile.data.id),
    genderIdMap,
    hasSoleAccess: activeOwnerProfiles.length === 1,
    requestActiveProfile: () => {
      ProfileActions.api.getProfile(profile.data.id);
    },
    goBack: () => {
      NavigationActions.goBack(history, RouteNames.profile());
    },
    goBackToGender: () => {
      NavigationActions.goBackTo(history, RouteNames.profileGender());
    },
    goBackToRace: () => {
      NavigationActions.goBackTo(history, RouteNames.profileRace());
    },
    goBackToProfile: () => {
      NavigationActions.goBackTo(history, RouteNames.profileInfo());
    },
    goToRaceSelfIdentity: () => {
      NavigationActions.goTo(history, RouteNames.profileRaceSelfIdentity(false));
    },
    loadInitialData: () => {},
    isResidenceStateRequired: (countryId) => {
      return listSelectors.isResidenceStateRequired(countryId, state);
    },
    isIntegrationsSupportedByCountry: (countryId) => {
      return listSelectors.isIntegrationsSupportedByCountry(state, countryId);
    },
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showNotification: systemNotificationActions.showNotification,
    dismissNotification: systemNotificationActions.dismissNotification,
    showSystemModal: systemModalActions.show,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MyProfileEditController));
